<script setup lang="ts">
  import { computed, defineProps } from 'vue';
  import { Info } from '@/types';

  const props = defineProps<{
    data: Info;
  }>();

  const goodSeller = computed(() => {
    return props.data.lic || props.data.renta;
  });
</script>

<template>
  <div class="mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md">
    <div v-if="!loader">
      <div class="flex justify-between">
        <div class="font-bold">Seller :</div>
        <div>
          <b>{{ data.sellerType }}</b>
          <span
            v-if="data.lic"
            class="font-bold"
            :class="{
              'text-green-500': goodSeller,
            }"
            >Insurance</span
          >
          <span
            class="font-bold"
            :class="{
              'text-red-500': !goodSeller,
            }"
            v-else-if="!data.lic && !data.renta"
            >Dealer</span
          >
          <span
            v-else-if="data.renta"
            class="font-bold"
            :class="{
              'text-green-500': goodSeller,
            }"
            >Rent</span
          >
        </div>
      </div>
      <div class="text-sm text-gray-700">
        Be careful! The dealer is not a reliable person. For more information,
        please refer to the work chat.
      </div>
    </div>
  </div>
</template>

<style scoped></style>
